// extracted by css-extract-rspack-plugin
export default {"crosshairContainer":"SXKLa0pEq4rgBph2","crosshairLine":"Jsq5HrJp8A04VLyh"};